import React from 'react';

import styled from 'styled-components';



const LineBreak = ({ block, ...props }) => {

  return (
    <IconBreak src={block.icon[0].url} />
  )
};


export default LineBreak;

const IconBreak = styled.img`
  width: 100%;
  height: auto;
  max-width: 25px;
  margin: 3em 0;
`;
